import { Messages } from '../../../../codegen/Localize';
import { setTags } from '../../../actions/SetTagsActions';
import { ISetTagsAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource, anyItemIsUnpublishedWorkbook } from './IEntityActionHelpers';

export const SetTagsAction: IEntityAction<IContentInfo, ISetTagsAction> = {
  name: EntityActionNames.SetTags,
  translateName: Messages.tag_action,
  isVisible: (targetItems: IContentInfo[]) => {
    if (anyItemIsUnpublishedWorkbook(targetItems)) {
      return false;
    }

    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetTagsAction) => !!(availableActions && availableActions.setTags),
  createReduxAction: (targetItems: IContentInfo[]) => setTags(...targetItems)
};
